/*-- SHOPIFY FORMS --*/
// Inject CSS into Shopify Forms Shadow DOM to custom styling
(function () {
	if (!window.formStyles) {
		window.formStyles = new Map();
	}

	const customCssRules = `
    ._textBody_2aowh_10 {
      text-align: left !important;
    }
    ._textBody_2aowh_10 p {
      color: var(--color-red-error) !important;
    }
		p[class^="_label"] {
      font-weight: 700 !important;
		}
    button[type="button"] {
      height: 60px !important;
      max-height: 60px !important;
    }
    button[type="submit"] {
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
      width: 100% !important;
      height: 60px !important;
      font-weight: 700 !important;
      background: #111 !important;
      color: #fff !important;
      border-radius: 60px !important;
      border: 1px solid rgba(255, 255, 255, .18) !important;
      padding: 0px !important;
      margin-top: 60px !important;
    }
    button[type="submit"]:hover {
      color: #fff !important;
      background-color: var(--color-yellow-custom) !important;
    }
    section[class^="_formContainer"] {
      max-width: 800px !important;
    }
		form {
			display: flex !important;
      flex-direction: row !important;
      justify-content: space-between !important;
			flex-wrap: wrap !important;
      gap: 10px !important;
		}
    form > div:nth-child(-n+3) {
      width: calc(33.33% - 10px);
    }
    form > div:nth-child(n+4):nth-child(-n+5) {
      width: calc(50% - 10px);
    }
    form > div:nth-child(-n+5) {
			display: inline-flex !important;
			flex-direction: column !important;
			flex: 0 0 auto !important;
		}
    form div[class^="_selectContainer"]:nth-child(5),
    form div[class^="_formFieldContainer"]:has(input[id*="company_name"]),
    form div[class^="_formFieldContainer"]:has(input[id*="company_country"]) {
      margin-bottom: 60px !important;
    }
    form div[class^="_formFieldContainer"] {
      width: calc(50% - 10px) !important;
      margin-top: 10px !important;
    }
    form div[class^="_formFieldContainer"] label {
      color: rgba(255, 255, 255, 0.6) !important;
    }
    form div[class^="_formFieldContainer"] input {
      color: rgba(255, 255, 255, 0.92) !important;
      height: 28px !important;
      max-height: 28px !important;
      background-color: rgba(15, 16, 18, 0.95) !important;
      color: rgba(255, 255, 255, 0.92) !important;
      border: 1px solid rgba(255, 255, 255, 0.16) !important;
      border-radius: 12px !important;
    }
    form div[class^="_formFieldContainer"]:has(input[id*="company_name"]),
    form div[class^="_formFieldContainer"]:has(input[id="email"]),
    form div[class^="_formFieldContainer"]:has(input[id="phone_number"]),
    form div[class^="_consentCheckboxContainer"] {
      width: 100% !important;
    }
    form div[class^="_formFieldContainer"]:has(input[id*="administrative_financial_contact_firstname"]),
    form div[class^="_formFieldContainer"]:has(input[id*="administrative_financial_contact_lastname"]) {
      margin-top: 0px !important;
    }
    form div[class^="_selectContainer"] {
      margin-top: 10px !important;
    }
    form div[class^="_selectContainer"] button {
      background-color: rgba(15, 16, 18, 0.95) !important;
      color: rgba(255, 255, 255, 0.92) !important;
      border: 1px solid rgba(255, 255, 255, 0.16) !important;
      border-radius: 12px !important;
    }
    ._formError_1mxsl_21 {
      display: none !important;
    }
	`;

	window.formStyles.set("megascopeShopifyFormsCustomStyles", customCssRules);
})();


/*-- EVENTS --*/
// DOMContentLoaded handler
document.addEventListener('DOMContentLoaded', function () {
  handleMainMenu();
  handleProductPageForm();
  handleCustomRegistrationForm();
  submitCustomResgistrationForm();
  setVariantPickerMessage();
  initFlatpickrLibrary();
  initCookieForMarket();

  // MEGASCOPE: Availability filter logic
  initAvailabilityFilters();
  
  // MEGASCOPE: Check product stock for buy button display
  initProductStockCheck();
  
  // MEGASCOPE: Filter products by variants (France vs International)
  // filterProductsByVariants();
  
  // MEGASCOPE: Auto-retry filters when new products are loaded dynamically
  // initProductFilterObserver();
});
// MEGASCOPE: Filter products by country and date availability
function initAvailabilityFilters() {
  const facetsContainer = document.querySelector('.collection__facets');
  if (!facetsContainer) {
    // We're not on a collection page, skip availability filters
    return;
  }
  
  setCountryISOInSelect();

  const dateInput = facetsContainer.querySelector('#filterAvailabilityByDates');
  const countryInput = facetsContainer.querySelector('#filterAvailabilityByCountry');

  const triggerFilter = (e) => {
    if (e.target && (e.target.id === 'filterAvailabilityByCountry' || e.target.id === 'filterAvailabilityByDates')) {
      filterProducts();
    }
  };

  facetsContainer.addEventListener('change', triggerFilter);
  facetsContainer.addEventListener('input', triggerFilter);

  if (dateInput) {
    dateInput.addEventListener('change', filterProducts);
  }

  if (countryInput || dateInput) {
    filterProducts();
  }
}

/**
 * Helper to parse date string (YYYY-MM-DD or DD-MM-YYYY)
 * @param {string} str
 * @returns {Date|null}
 */
function parseDate(str) {
  if (!str) return null;
  if (str.includes('-')) {
    const parts = str.split('-');
    if (parts[0].length === 4) return new Date(str); // YYYY-MM-DD
    // DD-MM-YYYY
    return new Date(parts[2], parts[1] - 1, parts[0]);
  }
  return null;
}

/**
 * Convert country select values to ISO3 in the filter select
 */
function setCountryISOInSelect() {
  var iso3Map = {
    "AF": "AFG","AL": "ALB","DZ": "DZA","AD": "AND","AO": "AGO","AR": "ARG","AM": "ARM","AU": "AUS","AT": "AUT","AZ": "AZE","BE": "BEL","BJ": "BEN","BT": "BTN","BO": "BOL","BA": "BIH","BW": "BWA","BR": "BRA","BN": "BRN","BG": "BGR","BF": "BFA","BI": "BDI","KH": "KHM","CM": "CMR","CA": "CAN","CV": "CPV","CF": "CAF","TD": "TCD","CL": "CHL","CN": "CHN","CO": "COL","KM": "COM","CG": "COG","CD": "COD","CR": "CRI","CI": "CIV","HR": "HRV","CU": "CUB","CY": "CYP","CZ": "CZE","DK": "DNK","DJ": "DJI","DM": "DMA","DO": "DOM","EC": "ECU","EG": "EGY","SV": "SLV","GQ": "GNQ","ER": "ERI","EE": "EST","ET": "ETH","FJ": "FJI","FI": "FIN","FR": "FRA","GA": "GAB","GM": "GMB","GE": "GEO","DE": "DEU","GH": "GHA","GR": "GRC","GD": "GRD","GT": "GTM","GN": "GIN","GW": "GNB","GY": "GUY","HT": "HTI","HN": "HND","HU": "HUN","IS": "ISL","IN": "IND","ID": "IDN","IR": "IRN","IQ": "IRQ","IE": "IRL","IL": "ISR","IT": "ITA","JM": "JAM","JP": "JPN","JO": "JOR","KZ": "KAZ","KE": "KEN","KI": "KIR","KP": "PRK","KR": "KOR","KW": "KWT","KG": "KGZ","LA": "LAO","LV": "LVA","LB": "LBN","LS": "LSO","LR": "LBR","LY": "LBY","LI": "LIE","LT": "LTU","LU": "LUX","MG": "MDG","MW": "MWI","MY": "MYS","MV": "MDV","ML": "MLI","MT": "MLT","MH": "MHL","MQ": "MTQ","MR": "MRT","MU": "MUS","MX": "MEX","FM": "FSM","MD": "MDA","MC": "MCO","MN": "MNG","ME": "MNE","MA": "MAR","MZ": "MOZ","MM": "MMR","NA": "NAM","NR": "NRU","NP": "NPL","NL": "NLD","NZ": "NZL","NI": "NIC","NE": "NER","NG": "NGA","NO": "NOR","OM": "OMN","PK": "PAK","PW": "PLW","PA": "PAN","PG": "PNG","PY": "PRY","PE": "PER","PH": "PHL","PL": "POL","PT": "PRT","QA": "QAT","RO": "ROU","RU": "RUS","RW": "RWA","KN": "KNA","LC": "LCA","VC": "VCT","WS": "WSM","SM": "SMR","ST": "STP","SA": "SAU","SN": "SEN","RS": "SRB","SC": "SYC","SL": "SLE","SG": "SGP","SK": "SVK","SI": "SVN","SB": "SLB","SO": "SOM","ZA": "ZAF","ES": "ESP","LK": "LKA","SD": "SDN","SR": "SUR","SZ": "SWZ","SE": "SWE","CH": "CHE","SY": "SYR","TW": "TWN","TJ": "TJK","TZ": "TZA","TH": "THA","TL": "TLS","TG": "TGO","TO": "TON","TT": "TTO","TN": "TUN","TR": "TUR","TM": "TKM","TV": "TUV","UG": "UGA","UA": "UKR","AE": "ARE","GB": "GBR","US": "USA","UY": "URY","UZ": "UZB","VU": "VUT","VA": "VAT","VE": "VEN","VN": "VNM","YE": "YEM","ZM": "ZMB","ZW": "ZWE"
  };
  const facetsContainer = document.querySelector('.collection__facets');
  if (!facetsContainer) return;
  const countrySelect = facetsContainer.querySelector('#filterAvailabilityByCountry');
  if (!countrySelect) return;
  for (var i = 0; i < countrySelect.options.length; i++) {
    var opt = countrySelect.options[i];
    // Shopify uses ISO2 for value, sometimes country name, sometimes both. Try to convert if possible.
    var iso2 = opt.value;
    if (iso2.length === 2 && iso3Map[iso2]) {
      opt.value = iso3Map[iso2];
    }
  }
}

// --- AVAILABILITY FILTER HELPERS (new MCH format) ---
/**
 * Filters product cards by country and date availability.
 * This function is triggered on filter change and on page load.
 */
function filterProducts() {
  // Get the country select element and its value ONLY inside .collection__facets
  let selectedCountry = '';
  const facetsContainer = document.querySelector('.collection__facets');
  let countrySelect = null;
  if (facetsContainer) {
    countrySelect = facetsContainer.querySelector('#filterAvailabilityByCountry');
    if (countrySelect) {
      selectedCountry = countrySelect.value;
    }
  }

  // Get the selected date range from the date input ONLY inside .collection__facets
  let selectedStart = null, selectedEnd = null;
  let dateInput = null;
  if (facetsContainer) {
    dateInput = facetsContainer.querySelector('#filterAvailabilityByDates');
    if (dateInput) {
      // If flatpickr stored Date objects, use them directly
      if (dateInput._selectedDates && Array.isArray(dateInput._selectedDates) && dateInput._selectedDates.length > 0) {
        selectedStart = dateInput._selectedDates[0] || null;
        selectedEnd = dateInput._selectedDates[1] || selectedStart;
      } else {
        // fallback legacy: parse string
        const val = dateInput.value;
        if (val) {
          const parts = val.split(' to ');
          selectedStart = parseDate(parts[0]);
          selectedEnd = parseDate(parts[1] || parts[0]);
        }
      }
    }
  }

  // Get all product cards with availability data
  const cards = document.querySelectorAll('product-card[data-availability]');

  cards.forEach(card => {
    const availRaw = card.getAttribute('data-availability');
    if (!availRaw) {
      card.style.display = 'none';
      return;
    }
    let avail;
    try {
      avail = JSON.parse(availRaw);
    } catch (e) {
      card.style.display = 'none';
      return;
    }
    const showByCountry = isCountryAvailable(avail, selectedCountry);
    const showByDate = isDateAvailable(avail, selectedStart, selectedEnd);
    
    // Check if hidden by market filter
    const isMarketFiltered = card.hasAttribute('data-market-filtered');
    
    if (showByCountry && showByDate && !isMarketFiltered) {
      card.style.display = '';
    } else {
      card.style.display = 'none';
    }
  });
}

/**
 * Checks if a product is available for the selected country (new MCH format).
 * New format: array of distribution modes, each with results[].groups[].countries[] + periods[]
 * A film is available if ANY distribution mode has the country with avail=YES.
 */
function isCountryAvailable(avail, selectedCountry) {
  if (!selectedCountry) return true;
  if (!Array.isArray(avail)) return false;
  for (const distMode of avail) {
    if (!Array.isArray(distMode?.results)) continue;
    for (const result of distMode.results) {
      if (!Array.isArray(result?.groups)) continue;
      for (const group of result.groups) {
        const countries = group?.countries || [];
        if (!countries.includes(selectedCountry) && !countries.includes("WORLD")) continue;
        const periods = group?.periods || [];
        if (periods.some(p => p && p.avail === 'YES')) return true;
      }
    }
  }
  return false;
}

/**
 * Checks if a product is available for the selected date range (new MCH format).
 * A film is available if ANY distribution mode has a period with avail=YES overlapping the range.
 */
function isDateAvailable(avail, selectedStart, selectedEnd) {
  if (!selectedStart || !selectedEnd) return true;
  if (!Array.isArray(avail)) return false;
  for (const distMode of avail) {
    if (!Array.isArray(distMode?.results)) continue;
    for (const result of distMode.results) {
      if (!Array.isArray(result?.groups)) continue;
      for (const group of result.groups) {
        const periods = group?.periods || [];
        for (const period of periods) {
          if (!period || period.avail !== 'YES') continue;
          const beg = parseDate(period.date_beg);
          const end = parseDate(period.date_end);
          if (beg <= selectedEnd && end >= selectedStart) return true;
        }
      }
    }
  }
  return false;
}


/*-- FUNCTIONS --*/
// Handle main menu items
function handleMainMenu() {
    const menuItems = document.querySelectorAll('#header-sidebar-menu ul li a');
    menuItems.forEach(item => {
        if (item.textContent.includes('Inscri')) {
            // Add a custom class to menu items containing the right term
            item.parentElement.classList.add('highlight');
        }
    });
}

// Handle the product page form
function handleProductPageForm() {
    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    const addToCartButton = form.querySelector('button[type="submit"]');
    const requiredFields = form.querySelectorAll('[required]');

    // Attach event listeners to required fields
    requiredFields.forEach(field => {
        field.addEventListener('input', checkFormValidity);
        field.addEventListener('change', checkFormValidity);
    });

    // Function to check form validity and enable/disable the "Add to Cart" button
    function checkFormValidity() {
        let allValid = true;
    
        // Check required fields
        requiredFields.forEach(field => {
            if (!field.value || (field.type === 'radio' && !field.checked)) {
                allValid = false;
            }
        });
    
        // Enable or disable the "Add to Cart" button based on validation
        if (allValid) {
            addToCartButton.classList.remove('disabled');
            addToCartButton.disabled = false;
        } else {
            addToCartButton.classList.add('disabled');
            addToCartButton.disabled = true;
        }
    }

    // Perform initial validation to set the button state
    checkFormValidity();

    const validationPending = document.querySelector('.customer-validation-pending');
    const loginSignupSection = document.querySelector('.product-login-signup');

    if ((validationPending || loginSignupSection) && addToCartButton) {
        // Hide the "Add to Cart" button
        addToCartButton.style.display = 'none';
    }
}

// Handle the custom registration form
function handleCustomRegistrationForm() {
    // Check if the page contains the `.custom-registration` section
    const registrationSection = document.querySelector('.custom-registration');
    if (!registrationSection) return; // Exit if the section is not present

    const organizationStatusSelect = document.getElementById('organizationStatus');
    let structureTypeForOperator = document.getElementById('structureTypeForOperator');
    let structureTypeForInstitution = document.getElementById('structureTypeForInstitution');

    // Function to toggle the structure fields in the DOM
    function toggleStructureFields() {
        const selectedValue = organizationStatusSelect.value;

        // Re-add the removed elements for toggling
        if (!structureTypeForOperator) {
            structureTypeForOperator = document.createElement('div');
            structureTypeForOperator.innerHTML = `
              <p class="field-title">Quel est le type de structure de votre organisation ?</p>
              <select name="structure_type" required>
                  <option value="cinema_independant" selected>Cinéma indépendant</option>
                  <option value="reseau_cinemas">Réseau de cinémas</option>
                  <option value="groupement">Groupement et entente de programmation</option>
                  <option value="cinema_itinerant">Cinéma itinérant</option>
                  <option value="festival_cinema">Festival de cinéma</option>
              </select>
            `;
            structureTypeForOperator.id = "structureTypeForOperator";
        }

        if (!structureTypeForInstitution) {
            structureTypeForInstitution = document.createElement('div');
            structureTypeForInstitution.innerHTML = `
              <p class="field-title">Quel est le type de structure de votre organisation ?</p>
              <select name="structure_type" required>
                  <option value="cinematheque">Cinémathèque</option>
                  <option value="mediatheque_bibliotheque">Médiathèque et bibliothèque publique</option>
                  <option value="centre_culturel">Centre culturel et maison de la culture</option>
                  <option value="ecole_univeersite">École et université</option>
                  <option value="musee">Musée</option>
                  <option value="collectivite_territoriale">Collectivité territoriale</option>
                  <option value="festivals_cinema_publics">Festivals de cinéma publics</option>
                  <option value="archives_nationales">Archives nationales</option>
                  <option value="autres">Autres</option>
              </select>
            `;
            structureTypeForInstitution.id = "structureTypeForInstitution";
        }

        // Remove and append elements based on the selected value
        if (selectedValue === 'exploitant') {
            structureTypeForInstitution.remove();
            document.querySelector('.custom-form-line').appendChild(structureTypeForOperator);
        } else {
            structureTypeForOperator.remove();
            document.querySelector('.custom-form-line').appendChild(structureTypeForInstitution);
        }
    }

    // Attach event listener to the dropdown
    organizationStatusSelect.addEventListener('change', toggleStructureFields);

    // Initialize visibility on page load
    toggleStructureFields();
};

function submitCustomResgistrationForm() {
  const form = document.getElementById('customSignupForm');
  const webhookUrl = 'https://hooks.zapier.com/hooks/catch/20973952/2shwihn/';

  if (form) {
      form.addEventListener('submit', async (event) => {
          event.preventDefault();

          // Collect form data
          const formData = new FormData(form);

          try {
              // Send form data to the webhook without setting a Content-Type header
              const response = await fetch(webhookUrl, {
                  method: 'POST',
                  body: formData, // Automatically sets the Content-Type to multipart/form-data
              });

              if (response.ok) {
                  const responseData = await response.json();
                  if (responseData.status === 'success') {
                      window.location.href = 'https://fuzubh-6r.myshopify.com/pages/confirmation-inscription';
                  } else {
                      console.error('Webhook response was not successful:', responseData);
                  }
              } else {
                  console.error('Error sending data to webhook:', response.statusText);
              }
          } catch (error) {
              console.error('Error:', error);
          }
      });
  } else {
      // We do nothing
  }
};

function setVariantPickerMessage () {
  // évite multi-init si la fonction est appelée plusieurs fois
  if (window.__msVariantMsgInit) return;
  window.__msVariantMsgInit = true;

  const messageContainer = document.getElementById('org-message');
  if (!messageContainer) return;

  const getLang = () =>
    location.pathname.includes('/en/') ? 'en'
    : location.pathname.includes('/es/') ? 'es'
    : 'fr';

  function updateMessage(value) {
    const v = String(value || '').toLowerCase();
    let text = '';

    if (/(exploitant|operator|operador)/.test(v)) {
      text = getLang()==='en'
        ? "The revenue sharing for this program is as follows: 50% for the operator, 50% for the distributor. A minimum guarantee of €70 excluding VAT will be required to cover technical costs."
        : getLang()==='es'
        ? "El reparto de ingresos para este programa es el siguiente: 50% para el operador, 50% para el distribuidor. Se exigirá una garantía mínima de 70€ sin IVA para cubrir los costes técnicos."
        : "Le partage des recettes sur ce programme est sur la base suivante : 50% pour l'exploitant, 50% pour le distributeur. Un minimum garanti de 70€ HT sera exigé pour couvrir les frais techniques.";
    } else if (/(association|asociac)/.test(v)) {
      text = getLang()==='en' ? "The fee is 300€ including VAT."
           : getLang()==='es' ? "El precio es 300€ IVA incluido."
                               : "Le tarif est de 300€ TTC.";
    }

    messageContainer.textContent = text;
    messageContainer.hidden = !text;
  }

  const selectors = [
    'select[name="option1"]',
    'input[type="radio"][name="option1"]',
    'select[name^="options["]',
    'input[type="radio"][name^="options["]'
  ];

  const getCurrentValue = () => {
    const sel = document.querySelector(selectors[0]) || document.querySelector('select[name^="options["]');
    if (sel && sel.tagName === 'SELECT') return sel.value;
    const checked = document.querySelector('input[type="radio"][name="option1"]:checked, input[type="radio"][name^="options["]:checked');
    return checked ? checked.value : '';
  };

  // init
  updateMessage(getCurrentValue());

  // écoute changement sur la page (delegation)
  document.addEventListener('change', (e) => {
    if (e.target && (e.target.matches(selectors.join(',')))) {
      updateMessage(getCurrentValue());
    }
  });

  // event thème
  document.addEventListener('variant:change', (e) => {
    const v = e?.detail?.variant;
    const option1 = v?.option1 || (Array.isArray(v?.options) ? v.options[0] : "");
    if (option1) updateMessage(option1);
  });

  // si le picker arrive plus tard, on refresh une fois quand on le voit
  const mo = new MutationObserver(() => {
    const found = document.querySelector(selectors.join(','));
    if (found) updateMessage(getCurrentValue());
  });
  mo.observe(document.body, { childList: true, subtree: true });
}

// run on DOM ready
// document.addEventListener('DOMContentLoaded', setVariantPickerMessage);


function initFlatpickrLibrary () {
  flatpickr("#projectionPeriodRange", {
    mode: "range",
    dateFormat: "d-m-Y",
    locale: "fr"
  });

  flatpickr("#ContactFestivalDates", {
    mode: "range",
    dateFormat: "d-m-Y",
    locale: "fr"
  });

  // Pour le filtre de dates, on veut des objets Date exploitables directement
  flatpickr("#filterAvailabilityByDates", {
    mode: "range",
    dateFormat: "Y-m-d", // format ISO facile à parser
    locale: "fr",
    allowInput: true,
    onChange: function(selectedDates, dateStr, instance) {
      // On stocke les objets Date dans l'input pour exploitation directe
      instance.input._selectedDates = selectedDates;
      // Déclenche le filtrage immédiatement
      if (typeof window.filterProducts === 'function') {
        window.filterProducts();
      }
    }
  });
};

function initCookieForMarket () {
  const marketCookieName = "user_market";
  const marketParam = getQueryParam("market");
  const splash = document.getElementById("market-splash");
  const changeMarketBtn = document.getElementById("changeMarketBtn");

  // Si le paramètre "market" est présent dans l'URL, mettre à jour le cookie
  if (marketParam) {
    setCookieForMarket(marketCookieName, marketParam, 24);
  }

  // Récupérer le cookie
  let marketCookie = getCookieForMarket(marketCookieName);
  
  // On met à jour la class du body
  setBodyClassForMarket(marketCookie);

  // Si aucun cookie n'est trouvé, afficher le splash screen
  if (!marketCookie) {
    if (splash) splash.style.display = "flex";
    document.body.classList.add("splash-screen-on");
  } else {
    // Si le cookie existe mais que l'URL n'a pas le paramètre, mettre à jour l'URL
    if (!marketParam) {
      let currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set("market", marketCookie);
      history.replaceState(null, "", currentUrl.toString());
    }
  }

  // Gestion du clic sur les boutons du splash screen
  const marketButtons = document.querySelectorAll(".market-btn");
  marketButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      const chosenMarket = this.getAttribute("data-market");
      setCookieForMarket(marketCookieName, chosenMarket, 24); // Met à jour le cookie pour 24h

      // 1) On récupère les segments de chemin sans préfixe de langue
      let segments = window.location.pathname.split("/").filter(Boolean);
      if (segments[0] && segments[0].length === 2) segments.shift();

      // 2) On reconstruit le nouveau path :
      //    - si FR (langue par défaut), pas de préfixe
      //    - si International, on ajoute "/en"
      const isIntl = chosenMarket.toLowerCase().includes("international");
      const prefix = isIntl ? "/en" : "";
      const newPath = prefix + (segments.length ? "/" + segments.join("/") : "");

      // 3) On construit la query string avec market= choisi
      const newUrl = newPath + "?market=" + encodeURIComponent(chosenMarket) + window.location.hash;

      // 4) Masquer splash et retirer la classe
      if (splash) splash.style.display = "none";
      document.body.classList.remove("splash-screen-on");
      setBodyClassForMarket(chosenMarket);

      // 5) Apply variant filter before redirect
      filterProductsByVariants();
      
      // 6) Redirection finale
      window.location.href = newUrl;
    });
  });

  // Gestion du bouton dans le header pour réafficher le splash screen
  if (changeMarketBtn) {
    changeMarketBtn.addEventListener("click", function () {
      if (splash) splash.style.display = "flex";
      document.body.classList.add("splash-screen-on");
    });
  }
};

function getCookieForMarket(name) {
  const dc = document.cookie;
  const prefix = name + "=";
  const begin = dc.indexOf("; " + prefix);
  if (begin === -1) {
    if (dc.indexOf(prefix) !== 0) return null;
    else return decodeURIComponent(dc.substring(prefix.length));
  } else {
    const start = begin + 2;
    const end = document.cookie.indexOf(";", start);
    return decodeURIComponent(document.cookie.substring(start + prefix.length, end === -1 ? dc.length : end));
  }
};

function setCookieForMarket(name, value, hours) {
  let expires = "";
  if (hours) {
    const date = new Date();
    date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/";
};

function getQueryParam(param) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
};

function setBodyClassForMarket (market) {
  if (market && market.toLowerCase().includes("international")) {
    document.body.classList.add("market-international");
  } else {
    document.body.classList.remove("market-international");
  }
};

// MEGASCOPE: Check if product is out of stock (all variants unavailable)
function checkProductOutOfStock() {
  // Check for product availability in the data attribute we added
  const productInfo = document.querySelector('.product-info[data-product-available]');
  if (!productInfo) return;
  
  const productAvailable = productInfo.dataset.productAvailable === 'true';
  
  // If product is not available (all variants are out of stock)
  if (!productAvailable) {
    document.body.classList.add("product-out-of-stock");
  } else {
    document.body.classList.remove("product-out-of-stock");
  }
}

// MEGASCOPE: Initialize stock checking when variant changes
function initProductStockCheck() {
  // Check on page load
  setTimeout(() => {
    checkProductOutOfStock();
  }, 100);
  
  // Listen for variant changes
  document.addEventListener('variant:change', function(event) {
    checkProductOutOfStock();
  });
  
  // Also listen for form changes as a fallback
  const variantPicker = document.querySelector('variant-picker');
  if (variantPicker) {
    variantPicker.addEventListener('change', function() {
      setTimeout(() => {
        checkProductOutOfStock();
      }, 50);
    });
  }
}


// MEGASCOPE: Filter products by variants (France vs International)
function filterProductsByVariants() {
  const marketCookie = getCookieForMarket("user_market");
  const isInternational = marketCookie && marketCookie.toLowerCase().includes("international");
  
  const cards = document.querySelectorAll('product-card');
  let hiddenCount = 0;
  
  cards.forEach(card => {
    const hasVariants = card.getAttribute('data-has-variants') === 'true';
    
    // Store original display state for other filters
    if (!card.hasAttribute('data-original-display')) {
      card.setAttribute('data-original-display', card.style.display || '');
    }
    
    if (!isInternational && !hasVariants) {
      // France market: hide products without variants
      card.style.display = 'none';
      card.setAttribute('data-variant-filtered', 'true');
      hiddenCount++;
    } else {
      // International market or product has variants: show
      card.removeAttribute('data-variant-filtered');
      card.style.display = card.getAttribute('data-original-display') || '';
    }
  });
  
  console.log(`Variant filter: ${hiddenCount} products hidden for France market (no variants)`);
}

// MEGASCOPE: Auto-retry filters when products are loaded dynamically
function initProductFilterObserver() {
  // Track the number of product cards to detect when new ones are added
  let lastProductCount = document.querySelectorAll('product-card').length;
  let filterTimeout = null;
  
  // Create observer to watch for new product cards
  const observer = new MutationObserver(function(mutations) {
    // Check if product count actually changed (only reliable indicator)
    const currentProductCount = document.querySelectorAll('product-card').length;
    
    if (currentProductCount !== lastProductCount && currentProductCount > 0) {
      console.log(`Product count changed: ${lastProductCount} → ${currentProductCount}`);
      lastProductCount = currentProductCount;
      
      // Throttle filter application to avoid too many calls
      if (filterTimeout) {
        clearTimeout(filterTimeout);
      }
      
      filterTimeout = setTimeout(function() {
        console.log('Reapplying filters due to product count change...');
        filterProductsByVariants();
        filterTimeout = null;
      }, 100);
    }
  });
  
  // Only observe specific containers where products are likely to be added
  const productContainer = document.querySelector('.collection__main, .product-grid, #product-grid');
  const targetElement = productContainer || document.body;
  
  observer.observe(targetElement, {
    childList: true,
    subtree: true
  });
  
  console.log('Product filter observer initialized - monitoring for product count changes');
}